import { StyleSheet } from 'react-native';
import Theme from 'Theme';
import { Device } from 'DeviceUtils';
import type { StylesMap } from 'Types';

let baseStyles: StylesMap = {
    container: {
        position: 'relative',
        flexDirection: 'column',
        padding: 12
    },
    bottomContainer: {
        flexDirection: 'row'
    },
    title: {
        width: '85%',
        fontFamily: Theme.regularFont,
        color: Theme.primaryTextColor,
        fontSize: 20,
        lineHeight: 28
    },
    subtitle: {
        width: '85%',
        fontFamily: Theme.regularFont,
        color: Theme.secondaryTextColor,
        fontSize: 16,
        paddingTop: 6
    },
    iconsContainer: {
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-end'
    },
    closeIcon: {
        width: 15,
        height: 15
    }
};

if (Device.isTabletOrWeb) {
    baseStyles = {
        ...baseStyles,
        title: {
            ...baseStyles.title,
            fontSize: 20
        }
    };
}

export default StyleSheet.create(baseStyles as any);
